import React from 'react'
import { useApp } from '../../../hooks/app'
import { MemberProfileType } from '../../../types/member_profile_type'
import { ProfileSwitcherItemsInterface } from '../components/profile-switcher-items-interface'

export const ProfileSwitcherOrganizations = (): JSX.Element => {
  const { user } = useApp()
  const members: MemberProfileType[] = React.useMemo(() => {
    return (user?.member_organizations || [])
      .filter((member) => member.status === 'ACCEPTED')
      .map((member) => ({
        kind: 'organization',
        key: `organization::${member.organization_id}`,
        label: member.organization?.name || 'unknown',
        value: member,
      }))
  }, [user])

  return (
    <ProfileSwitcherItemsInterface profile="organization" members={members} />
  )
}
